import React from "react";
import {Icon} from "../../../themes/userq/Icon/Icon";
import {Text} from "../../../themes/userq/Text/Text";
import {Button} from "../../../themes/userq/Button/Button";

export default function FirstClickTestIntroduction({goToFirstTask,testlanguage,test}){
    return (
        <div className="tester-page-wrapper tester-welcome-page-wrap card-sorting-introduction">
            <div className="container inner-page-container">
                <div className="taking-test-page-height">
                <div className="tester-screens-hold">
                    <div className="tester-selected-page-wrap">
                        <div className="selected-page-right-side">
                            <div className="selected-test-info-img">
                               
                                    <img src={process.env.REACT_APP_URL+"img/firstclick-placeholder.svg"}/>
                                
                            </div>
                        </div>


                        <div className={`selected-page-left-side ${testlanguage=="ar"?"arabic_wrapper":""}`}>
                            <Text type={"h1"}>
                                {testlanguage=="en"?"First click":"اختبار النقرة الأولى"}
                            </Text>
                            
                            <Text type={"body-text-1"} fontWeight={'medium-font'}>
                                {testlanguage=="en"?
                                    "You will be presented with a web page or an app screen, and we will give you a task to complete. Please read the task instructions carefully, and then click on the first place where you would start to complete the task."
                                    :"سيتم تزويدك بصفحة ويب أو شاشة تطبيق، و سنعطيك مهمة لإكمالها. يرجى قراءة تعليمات المهمة بعناية، ثم انقر فوق المكان الأول الذي ستبدأ فيه لإكمال المهمة."}
                            </Text>
                            

                            <div className={'remember-text'}>
                                <Text type={"body-text-3"} fontWeight={'medium-font'}>
                                    {testlanguage=="en"?"Remember, there’s no right or wrong answer here - just observe as you would do naturally."
                                        :"تذكر أنه لا توجد إجابة صحيحة أو خاطئة هنا - فقط لاحظ كما تفعل بشكل طبيعي."}
                                </Text>
                            </div>

                            <div className="button-wrapper none-for-mobile">
                                <Button
                                    size={'large'}
                                    iconRight={<Icon colorClass={"gray-50-svg"} value={testlanguage=="ar"?'back-arrow':'forward-arrow'}/>}
                                    label={testlanguage == "en" ? "Let’s start" : "لنبدأ"}
                                    onClick={() => {
                                        goToFirstTask();
                                    }}
                                />
                            </div>
                        </div>

                    </div>
                </div>
                </div>

                <div className="button-wrapper none-for-desktop taking-test-button">
                    <Button
                        size={'large'}
                        iconRight={<Icon colorClass={"gray-50-svg"} value={testlanguage=="ar"?'back-arrow':'forward-arrow'}/>}
                        label={testlanguage=="en"?"Let’s start":"لنبدأ"}
                        onClick={() => {
                            goToFirstTask();
                        }}
                    />
                </div>
            </div>
        </div>
    );
}